export const translations = {
  es: {
    common: {
      loading: 'Cargando...',
      home: 'Home',
      viewMore: 'Ver más',
      by: 'Por',
      product: 'Producto',
      products: 'Productos',
      close: 'Cerrar',
      account: 'Mi cuenta',
      searchProducts: 'Buscar productos...',
      inStock: 'En stock',
      outOfStock: 'Agotado',
      lowStock: 'Últimas unidades',
      readyToShip: 'En stock y listo para enviar',
      previous: 'Anterior',
      next: 'Siguiente',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      save: 'Guardar',
      saving: 'Guardando...',
      default: 'Predeterminado',
    },
    header: {
      announcement: 'Suscríbete y obten un 20% de descuento en tu primera compra.',
      announcementCta: 'Suscríbete Ahora',
      signedIn: 'Sesión iniciada',
      guestSession: 'Sesión temporal',
      guestMode: 'Modo Invitado',
      logout: 'Cerrar sesión',
      adminPanel: 'Ir a mi Panel',
      cart: 'Carrito',
    },
    cart: {
      title: 'Tu carrito de compra',
      empty: 'Tu carrito está vacío',
      productSingular: 'PRODUCTO',
      productPlural: 'PRODUCTOS',
      inCart: 'EN TU CARRITO',
      close: 'Cerrar carrito',
      quantity: 'Cantidad',
      size: 'Talla',
      change: 'Cambiar',
      remove: 'Eliminar producto',
      decrease: 'Disminuir cantidad',
      increase: 'Aumentar cantidad',
      freeShippingProgress: '¡Estás a ${amount} de obtener envío gratis!',
      freeShippingUnlocked: '¡Tienes envío gratis!',
      subtotal: 'Subtotal',
      shipping: 'Envío',
      shippingNextStep: 'Calculado en el siguiente paso',
      estimatedTotal: 'Total estimado',
      checkout: 'Ir a pagar',
    },
    auth: {
      welcome: '¡Bienvenido!',
      signIn: 'Iniciar Sesión',
      optionsSubtitle: 'Inicia sesión o continua como invitado para finalizar tu compra',
      adminSubtitle: 'Ingresa tus datos para acceder al panel admin',
      accountSubtitle: 'Ingresa tus datos para acceder a tu cuenta',
      google: 'Continuar con Google',
      or: 'o',
      emailLogin: 'Iniciar sesión con correo',
      continueGuest: 'Continuar como invitado',
      email: 'Correo electrónico',
      password: 'Contraseña',
      hidePassword: 'Ocultar contraseña',
      showPassword: 'Mostrar contraseña',
      signingIn: 'Ingresando...',
      submit: 'Ingresar',
      benefitsTitle: 'Al crear una cuenta podrás:',
      benefitOrders: 'Ver y gestionar tus pedidos',
      benefitData: 'Guardar tus datos para futuras compras',
      benefitOffers: 'Acceder a ofertas y lanzamientos exclusivos',
      noAccount: '¿No tienes una cuenta?',
      createAccount: 'Crear Cuenta',
      error: 'Error al iniciar sesión',
    },
    shop: {
      heroTitle: 'Merch oficial de creadores',
      heroSubtitle: 'Explora productos y colecciones oficiales creados junto a tus creadores favoritos.',
      all: 'TODOS',
      allLabel: 'Todos',
      filters: 'Filtros',
      clearAll: 'Limpiar todo',
      categories: 'Categorías',
      sortBy: 'Ordenar por:',
      popular: 'Más Popular',
      priceRange: 'Rango de Precio',
      availability: 'Disponibilidad',
      collectionsCreators: 'Colecciones/Creadores',
      noProducts: 'No se encontraron productos',
      noProductsHint: 'Intenta seleccionar otra categoría o eliminar los filtros.',
      viewAllProducts: 'Ver todos los productos',
      addToCart: 'Agregar al carrito',
      requestsDescription: 'Impulsa a tus creadores favoritos y ayúdalos a convertir sus ideas en productos reales. Apóyalos antes del lanzamiento.',
      allCategories: 'Todos',
      noRequests: 'No hay peticiones disponibles',
      noRequestsHint: 'Intenta ajustar los filtros o vuelve más tarde',
      petitions: 'Peticiones',
      petitionsCount: 'peticiones',
    },
    product: {
      viewProduct: 'Ver producto',
      notFound: 'Producto no encontrado',
      limitedEdition: 'EDICIÓN LIMITADA',
      quantity: 'Cantidad',
      addToCart: 'Agregar al carrito',
      buyNow: 'Comprar Ahora',
      defaultDescription: 'Peluche oficial diseñado en colaboración con el creador. Elaborado con materiales de alta calidad y acabados premium.',
      designedWith: 'Diseñado junto a',
      securePurchase: 'Compra segura y protegida',
      details: 'Detalles',
      shippingRefunds: 'Envíos/Reembolsos',
      material: 'Material',
      filling: 'Relleno',
      approximateHeight: 'Altura aproximada',
      approximateWeight: 'Peso aproximado',
      embroidery: 'Bordados',
      materialValue: 'Felpa premium ultra suave',
      fillingValue: 'Fibra de Poliéster de alta calidad',
      embroideryValue: 'Alta precisión',
      shippingText1: 'Realizamos envíos nacionales e internacionales.',
      shippingText2: 'Los tiempos de entrega pueden variar según la ubicación y la empresa de transporte. Recibirás un número de seguimiento una vez despachado tu pedido. Los costos de envío se calculan al finalizar la compra.',
      returnsAccepted: 'Se aceptan devoluciones si:',
      returnDamaged: 'El producto llega dañado.',
      returnWrong: 'El producto recibido es incorrecto.',
      returnDefect: 'El pedido presenta defectos de fabricación.',
      returnContact: 'Si tu pedido presenta algún inconveniente, contáctanos dentro de los primeros 7 días posteriores a la recepción, adjuntando fotografías del producto.',
      related: 'También podría interesarte...',
      added: 'Agregado al carrito',
      addError: 'Error al agregar',
      plushies: 'Peluches',
      sold: 'vendidos',
      notifyMe: 'Notificarme',
      hoursLeft: 'h restantes',
    },
    checkout: {
      title: 'Finalizar Compra',
      subtitle: 'Estamos a un paso de que recibas tus productos',
      cart: 'Carrito',
      checkout: 'Checkout',
      step1: 'Paso 1',
      shipping: 'Envío',
      step2: 'Paso 2 de 3',
      payment: 'Pago',
      step3: 'Paso 3',
      billingData: 'Datos de facturación',
      firstName: 'Nombre',
      lastName: 'Apellido',
      country: 'País',
      phone: 'Numero de celular',
      idNumber: 'Numero de Identificación',
      address: 'Dirección',
      reference: 'Referencia',
      city: 'Ciudad',
      region: 'Región/Estado',
      selectRegion: 'Selecciona tu región',
      zipCode: 'Codigo Postal',
      email: 'Correo Electrónico',
      notes: 'Notas (Opcional)',
      backToCart: 'Volver al Carrito',
      orderSummary: 'Resumen de pedido',
      noProducts: 'No hay productos',
      quantity: 'Cantidad',
      products: 'Productos',
      taxes: 'Impuestos',
      totalToPay: 'Total a pagar',
      estimatedShipping: 'Envío estimado',
      securePurchase: 'Compra 100% segura',
      secureData: 'Tus datos están protegidos con encriptación',
      processing: 'Procesando...',
      continuePayment: 'Continuar con el pago',
      created: 'Pedido creado con éxito, redirigiendo al pago...',
      placeholders: {
        firstName: 'Tu nombre',
        lastName: 'Tu apellido',
        phone: 'Numero de celular',
        doc: 'Escribe tu DNI, C.E., RUC',
        address: 'Calle, avenida, departamento, número, etc.',
        reference: 'Ej: piso 2, frente al parque..',
        city: 'Tu ciudad',
        zipCode: 'Ej: 20234',
        email: 'correo@ejemplo.com',
      },
    },
    account: {
      profile: 'Perfil',
      orders: 'Pedidos',
      addresses: 'Direcciones',
      reviews: 'Mis Opiniones',
      security: 'Seguridad',
      hello: 'Hola',
      user: 'Usuario',
      manageAccount: 'Gestiona tu cuenta de MiskiPOP',
      customerSince: 'Cliente desde',
      loadingProfile: 'Cargando perfil...',
      personalInfo: 'Información personal',
      personalInfoHint: 'Actualiza tus datos personales y de contacto',
      gender: 'Género',
      male: 'Hombre',
      female: 'Mujer',
      preferNotSay: 'Prefiero no decirlo',
      firstName: 'Nombre',
      lastName: 'Apellido',
      phone: 'Número de teléfono',
      birthDate: 'Fecha de nacimiento',
      saveChanges: 'Guardar cambios',
      profileUpdated: 'Perfil actualizado correctamente',
      completedOrders: 'Pedidos realizados',
      registeredAddresses: 'Direcciones registradas',
      favoriteProducts: 'Productos favoritos',
      myOrders: 'Mis pedidos',
      ordersHint: 'Revisa el estado de todos tus pedidos',
      loadingOrders: 'Cargando pedidos...',
      myAddresses: 'Mis direcciones',
      addressesHint: 'Revisa el detalle de tus direcciones para el envío de tus pedidos',
      noAddresses: 'No tienes direcciones registradas',
      editAddress: 'Editar dirección',
      newAddress: 'Nueva dirección',
      label: 'Etiqueta',
      homeLabel: 'Casa',
      officeLabel: 'Oficina',
      otherLabel: 'Otro',
      street: 'Calle / Avenida',
      district: 'Distrito',
      city: 'Ciudad',
      saveAddress: 'Guardar dirección',
      securityTitle: 'Seguridad',
      securityHint: 'Administra tu contraseña y configuración de seguridad',
      passwordComingSoon: 'Próximamente podrás cambiar tu contraseña aquí.',
      currentPassword: 'Contraseña actual',
      newPassword: 'Nueva contraseña',
      confirmNewPassword: 'Confirmar nueva contraseña',
      updatePassword: 'Actualizar contraseña',
      createPassword: 'Crear contraseña',
      passwordUpdated: 'Contraseña actualizada. Inicia sesión nuevamente.',
      passwordRequired: 'Este campo es obligatorio',
      passwordTooShort: 'Debe tener al menos 8 caracteres',
      passwordMismatch: 'Las contraseñas no coinciden',
      passwordSameAsCurrent: 'La nueva contraseña debe ser diferente a la actual',
      passwordIncorrect: 'La contraseña actual es incorrecta',
      googlePasswordHint: 'Tu cuenta usa Google. Crea una contraseña para también poder iniciar sesión con tu correo.',
      showPassword: 'Mostrar contraseña',
      hidePassword: 'Ocultar contraseña',
      emailVerification: 'Verificación de la cuenta',
      emailVerified: 'Verificado',
      changeEmail: 'Cambiar correo',
      changeEmailTitle: 'Cambiar correo electrónico',
      changeEmailDescription: 'Tu correo se usa para iniciar sesión, recibir confirmaciones de pedido y avisos de envío.',
      changeEmailHint: 'Tus pedidos actuales y futuros quedan asociados a tu cuenta sin importar el correo. Si el nuevo correo coincide con otra cuenta sin pedidos, se fusionarán automáticamente.',
      newEmail: 'Nuevo correo electrónico',
      changeEmailSubmit: 'Guardar correo',
      selectCountry: 'Selecciona un país',
      noOrders: 'No tienes pedidos aún',
      noOrdersHint: 'Cuando realices un pedido, aparecerá aquí',
      urbanization: 'Urbanización',
      zipCode: 'Código Postal',
      country: 'País',
      changePhoto: 'Cambiar foto',
      addAddress: 'Agregar dirección',
      status: {
        PENDING: 'Pendiente',
        CONFIRMED: 'Confirmado',
        PROCESSING: 'En preparación',
        SHIPPED: 'En camino',
        IN_TRANSIT: 'En camino',
        TRACKING_PENDING: 'Tracking por enviar',
        DELIVERED: 'Entregado',
        CANCELLED: 'Cancelado',
        REFUNDED: 'Reembolsado',
        cancelledSubtext: 'Pedido cancelado',
        estimatedArrival: 'Llegada estimada',
        registered: 'Pedido registrado',
        confirmed: 'Pedido confirmado',
        processing: 'En preparación',
      },
    },
    waitingRoom: {
      checking: 'Verificando tu posición...',
      title: 'Sala de Espera',
      busy: 'Hay mucha gente interesada. Tu posición:',
      estimated: 'Tiempo estimado',
      autoRefresh: 'Esta página se actualiza automáticamente. No la cierres.',
    },
    footer: {
      followUs: 'Síguenos',
    },
    home: {
      peticiones: 'PETICIONES',
      viewCatalog: 'Ver catálogo',
      merchTitle: 'Colecciones disponibles',
      lastChance: 'Última Oportunidad',
      upcoming: 'Próximamente',
      categories: 'CATEGORÍAS',
      benefitsTitle: '¿POR QUÉ COMPRAR CON MiskiPOP?',
      reviewsSubtitle: 'Nos respalda la confianza de personas que confían en nosotros',
      collectionAlt: 'Colección MiskiPOP',
      categoryDescription: 'Explora la colección',
      creatorCtaTitle: '¿Listo para lanzar tu propia colección con MiskiPOP?',
      creatorCtaDescription: 'Te acompañamos en cada etapa: diseño, producción, promoción y venta.',
      creatorCtaNote: 'Sin riesgos. Sin complicaciones. 100% MiskiPOP.',
      creatorEyebrow: 'CREADO PARA LA COMUNIDAD',
      creatorTitle: 'Descubre productos únicos para ti',
      creatorDescription: 'Explora una selección especial de productos cuidadosamente elegidos para ofrecerte calidad, estilo y originalidad.',
      creatorsTitle: 'Explora a nuestros creadores',
      learnMore: 'Conoce más',
      happyFans: 'NUESTROS FANS FELICES',
      newsletterTitle: 'NO TE PIERDAS LANZAMIENTOS EXCLUSIVOS',
      newsletterSubtitle: 'Recibe descuentos, novedades y colecciones limitadas',
      newsletterButton: 'Suscribirse',
      newsletterThanks: '¡Gracias por suscribirte!',
      noProductsAvailable: 'No hay productos disponibles',
    },
  },
  en: {
    common: {
      loading: 'Loading...',
      home: 'Home',
      viewMore: 'View more',
      by: 'By',
      product: 'Product',
      products: 'Products',
      close: 'Close',
      account: 'My account',
      searchProducts: 'Search products...',
      inStock: 'In stock',
      outOfStock: 'Sold out',
      lowStock: 'Last units',
      readyToShip: 'In stock and ready to ship',
      previous: 'Previous',
      next: 'Next',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      save: 'Save',
      saving: 'Saving...',
      default: 'Default',
    },
    header: {
      announcement: 'Subscribe and get 20% off your first purchase.',
      announcementCta: 'Subscribe now',
      signedIn: 'Signed in',
      guestSession: 'Temporary session',
      guestMode: 'Guest mode',
      logout: 'Log out',
      adminPanel: 'Go to my panel',
      cart: 'Cart',
    },
    cart: {
      title: 'Your shopping cart',
      empty: 'Your cart is empty',
      productSingular: 'ITEM',
      productPlural: 'ITEMS',
      inCart: 'IN YOUR CART',
      close: 'Close cart',
      quantity: 'Quantity',
      size: 'Size',
      change: 'Change',
      remove: 'Remove product',
      decrease: 'Decrease quantity',
      increase: 'Increase quantity',
      freeShippingProgress: 'You are ${amount} away from free shipping!',
      freeShippingUnlocked: 'You have free shipping!',
      subtotal: 'Subtotal',
      shipping: 'Shipping',
      shippingNextStep: 'Calculated in the next step',
      estimatedTotal: 'Estimated total',
      checkout: 'Checkout',
    },
    auth: {
      welcome: 'Welcome!',
      signIn: 'Sign in',
      optionsSubtitle: 'Sign in or continue as guest to complete your purchase',
      adminSubtitle: 'Enter your details to access the admin panel',
      accountSubtitle: 'Enter your details to access your account',
      google: 'Continue with Google',
      or: 'or',
      emailLogin: 'Sign in with email',
      continueGuest: 'Continue as guest',
      email: 'Email address',
      password: 'Password',
      hidePassword: 'Hide password',
      showPassword: 'Show password',
      signingIn: 'Signing in...',
      submit: 'Sign in',
      benefitsTitle: 'When you create an account you can:',
      benefitOrders: 'View and manage your orders',
      benefitData: 'Save your details for future purchases',
      benefitOffers: 'Access exclusive offers and launches',
      noAccount: "Don't have an account?",
      createAccount: 'Create Account',
      error: 'Error signing in',
    },
    shop: {
      heroTitle: 'Official creator merch',
      heroSubtitle: 'Explore official products and collections created with your favorite creators.',
      all: 'ALL',
      allLabel: 'All',
      filters: 'Filters',
      clearAll: 'Clear all',
      categories: 'Categories',
      sortBy: 'Sort by:',
      popular: 'Most popular',
      priceRange: 'Price range',
      availability: 'Availability',
      collectionsCreators: 'Collections/Creators',
      noProducts: 'No products found',
      noProductsHint: 'Try another category or remove filters.',
      viewAllProducts: 'View all products',
      addToCart: 'Add to cart',
      requestsDescription: 'Support your favorite creators and help them turn their ideas into real products. Back them before launch.',
      allCategories: 'All',
      noRequests: 'No petitions available',
      noRequestsHint: 'Try adjusting the filters or come back later',
      petitions: 'Petitions',
      petitionsCount: 'petitions',
    },
    product: {
      viewProduct: 'View product',
      notFound: 'Product not found',
      limitedEdition: 'LIMITED EDITION',
      quantity: 'Quantity',
      addToCart: 'Add to cart',
      buyNow: 'Buy now',
      defaultDescription: 'Official plush designed in collaboration with the creator. Made with high-quality materials and premium finishes.',
      designedWith: 'Designed with',
      securePurchase: 'Secure and protected purchase',
      details: 'Details',
      shippingRefunds: 'Shipping/Refunds',
      material: 'Material',
      filling: 'Filling',
      approximateHeight: 'Approximate height',
      approximateWeight: 'Approximate weight',
      embroidery: 'Embroidery',
      materialValue: 'Ultra-soft premium plush',
      fillingValue: 'High-quality polyester fiber',
      embroideryValue: 'High precision',
      shippingText1: 'We ship nationally and internationally.',
      shippingText2: 'Delivery times may vary depending on location and carrier. You will receive a tracking number once your order has shipped. Shipping costs are calculated at checkout.',
      returnsAccepted: 'Returns are accepted if:',
      returnDamaged: 'The product arrives damaged.',
      returnWrong: 'The received product is incorrect.',
      returnDefect: 'The order has manufacturing defects.',
      returnContact: 'If your order has any issue, contact us within the first 7 days after delivery and include product photos.',
      related: 'You may also like...',
      added: 'Added to cart',
      addError: 'Error adding product',
      plushies: 'Plushies',
      sold: 'sold',
      notifyMe: 'Notify me',
      hoursLeft: 'h left',
    },
    checkout: {
      title: 'Checkout',
      subtitle: 'You are one step away from receiving your products',
      cart: 'Cart',
      checkout: 'Checkout',
      step1: 'Step 1',
      shipping: 'Shipping',
      step2: 'Step 2 of 3',
      payment: 'Payment',
      step3: 'Step 3',
      billingData: 'Billing details',
      firstName: 'First name',
      lastName: 'Last name',
      country: 'Country',
      phone: 'Phone number',
      idNumber: 'Identification number',
      address: 'Address',
      reference: 'Reference',
      city: 'City',
      region: 'Region/State',
      selectRegion: 'Select your region',
      zipCode: 'Postal code',
      email: 'Email address',
      notes: 'Notes (Optional)',
      backToCart: 'Back to cart',
      orderSummary: 'Order summary',
      noProducts: 'No products',
      quantity: 'Quantity',
      products: 'Products',
      taxes: 'Taxes',
      totalToPay: 'Total to pay',
      estimatedShipping: 'Estimated shipping',
      securePurchase: '100% secure purchase',
      secureData: 'Your data is protected with encryption',
      processing: 'Processing...',
      continuePayment: 'Continue to payment',
      created: 'Order created successfully, redirecting to payment...',
      placeholders: {
        firstName: 'Your first name',
        lastName: 'Your last name',
        phone: 'Phone number',
        doc: 'Enter your ID, tax ID, or passport',
        address: 'Street, avenue, apartment, number, etc.',
        reference: 'E.g. second floor, across from the park',
        city: 'Your city',
        zipCode: 'E.g. 20234',
        email: 'email@example.com',
      },
    },
    account: {
      profile: 'Profile',
      orders: 'Orders',
      addresses: 'Addresses',
      reviews: 'My Reviews',
      security: 'Security',
      hello: 'Hi',
      user: 'User',
      manageAccount: 'Manage your MiskiPOP account',
      customerSince: 'Customer since',
      loadingProfile: 'Loading profile...',
      personalInfo: 'Personal information',
      personalInfoHint: 'Update your personal and contact details',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      preferNotSay: 'Prefer not to say',
      firstName: 'First name',
      lastName: 'Last name',
      phone: 'Phone number',
      birthDate: 'Date of birth',
      saveChanges: 'Save changes',
      profileUpdated: 'Profile updated successfully',
      completedOrders: 'Completed orders',
      registeredAddresses: 'Registered addresses',
      favoriteProducts: 'Favorite products',
      myOrders: 'My orders',
      ordersHint: 'Review the status of all your orders',
      loadingOrders: 'Loading orders...',
      myAddresses: 'My addresses',
      addressesHint: 'Review your delivery addresses for future orders',
      noAddresses: 'You have no saved addresses',
      editAddress: 'Edit address',
      newAddress: 'New address',
      label: 'Label',
      homeLabel: 'Home',
      officeLabel: 'Office',
      otherLabel: 'Other',
      street: 'Street / Avenue',
      district: 'District',
      city: 'City',
      saveAddress: 'Save address',
      securityTitle: 'Security',
      securityHint: 'Manage your password and security settings',
      passwordComingSoon: 'Soon you will be able to change your password here.',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmNewPassword: 'Confirm new password',
      updatePassword: 'Update password',
      createPassword: 'Create password',
      passwordUpdated: 'Password updated. Please sign in again.',
      passwordRequired: 'This field is required',
      passwordTooShort: 'Must be at least 8 characters',
      passwordMismatch: 'Passwords do not match',
      passwordSameAsCurrent: 'New password must be different from current',
      passwordIncorrect: 'Current password is incorrect',
      googlePasswordHint: 'Your account uses Google. Create a password so you can also sign in with your email.',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      emailVerification: 'Account verification',
      emailVerified: 'Verified',
      changeEmail: 'Change email',
      changeEmailTitle: 'Change email address',
      changeEmailDescription: 'Your email is used to sign in, receive order confirmations and shipping notifications.',
      changeEmailHint: 'Your current and future orders stay linked to your account regardless of the email. If the new email belongs to another account without orders, it will be merged automatically.',
      newEmail: 'New email address',
      changeEmailSubmit: 'Save email',
      selectCountry: 'Select a country',
      noOrders: 'You do not have orders yet',
      noOrdersHint: 'When you place an order, it will appear here',
      urbanization: 'Neighborhood',
      zipCode: 'Postal code',
      country: 'Country',
      changePhoto: 'Change photo',
      addAddress: 'Add address',
      status: {
        PENDING: 'Pending',
        CONFIRMED: 'Confirmed',
        PROCESSING: 'Preparing',
        SHIPPED: 'On the way',
        IN_TRANSIT: 'On the way',
        TRACKING_PENDING: 'Tracking pending',
        DELIVERED: 'Delivered',
        CANCELLED: 'Cancelled',
        REFUNDED: 'Refunded',
        cancelledSubtext: 'Order cancelled',
        estimatedArrival: 'Estimated arrival',
        registered: 'Order registered',
        confirmed: 'Order confirmed',
        processing: 'Preparing',
      },
    },
    waitingRoom: {
      checking: 'Checking your position...',
      title: 'Waiting room',
      busy: 'There is a lot of interest. Your position:',
      estimated: 'Estimated time',
      autoRefresh: 'This page updates automatically. Do not close it.',
    },
    footer: {
      followUs: 'Follow us',
    },
    home: {
      peticiones: 'REQUESTS',
      viewCatalog: 'View catalog',
      merchTitle: 'Available collections',
      lastChance: 'Last Chance',
      upcoming: 'Coming Soon',
      categories: 'CATEGORIES',
      benefitsTitle: 'WHY BUY WITH MiskiPOP?',
      reviewsSubtitle: 'We are backed by the trust of people who believe in us',
      collectionAlt: 'MiskiPOP Collection',
      categoryDescription: 'Explore the collection',
      creatorCtaTitle: 'Ready to launch your own collection with MiskiPOP?',
      creatorCtaDescription: 'We support you at every stage: design, production, promotion, and sales.',
      creatorCtaNote: 'No risk. No complications. 100% MiskiPOP.',
      creatorEyebrow: 'MADE FOR THE COMMUNITY',
      creatorTitle: 'Discover unique products made for you',
      creatorDescription: 'Explore a special selection of products carefully chosen for quality, style, and originality.',
      creatorsTitle: 'Explore our creators',
      learnMore: 'Learn more',
      happyFans: 'HAPPY FANS',
      newsletterTitle: 'DO NOT MISS EXCLUSIVE LAUNCHES',
      newsletterSubtitle: 'Get discounts, updates, and limited collections',
      newsletterButton: 'Subscribe',
      newsletterThanks: 'Thanks for subscribing!',
      noProductsAvailable: 'No products available',
    },
  },
};
